var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrowning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 28.1905C22.7324 28.1905 28.1903 22.7326 28.1903 16C28.1903 9.26745 22.7324 3.80957 15.9998 3.80957C9.26721 3.80957 3.80933 9.26745 3.80933 16C3.80933 22.7326 9.26721 28.1905 15.9998 28.1905Z",
    fill: "url(#paint0_radial_179_9011)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.9998 28.1905C22.7324 28.1905 28.1903 22.7326 28.1903 16C28.1903 9.26745 22.7324 3.80957 15.9998 3.80957C9.26721 3.80957 3.80933 9.26745 3.80933 16C3.80933 22.7326 9.26721 28.1905 15.9998 28.1905Z",
    fill: "url(#paint1_radial_179_9011)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9201 11.7105C14.0497 11.2381 13.6154 10.8038 12.7392 10.5677C11.9925 10.3695 10.2478 10.3391 8.73155 11.4895C8.44967 11.7029 8.73155 11.9315 8.98299 11.8172C9.83631 11.4134 11.8935 11.1543 13.303 11.7029C13.8668 11.9238 13.9201 11.7105 13.9201 11.7105Z",
    fill: "url(#paint2_linear_179_9011)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0156 16.655C12.6636 16.655 13.1889 15.8602 13.1889 14.8797C13.1889 13.8993 12.6636 13.1045 12.0156 13.1045C11.3676 13.1045 10.8423 13.8993 10.8423 14.8797C10.8423 15.8602 11.3676 16.655 12.0156 16.655Z",
    fill: "url(#paint3_radial_179_9011)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0156 13.6991C12.5184 13.6991 12.9604 14.141 13.1889 14.7886C13.1737 13.8286 12.6556 13.0591 12.0156 13.0591C11.3756 13.0591 10.8575 13.8286 10.8423 14.7886C11.0708 14.141 11.5128 13.6991 12.0156 13.6991Z",
    fill: "url(#paint4_linear_179_9011)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8879 23.3448C10.987 23.36 11.0784 23.3296 11.147 23.2686C12.3888 22.1714 14.3088 21.5772 15.7488 21.5772H16.0003H16.2517C17.6917 21.5772 19.6117 22.1714 20.8536 23.2686C20.9222 23.3296 21.0212 23.36 21.1126 23.3448C21.2117 23.3296 21.265 23.2229 21.2117 23.1391C20.1526 21.4019 18.187 20.3276 16.0612 20.3276H16.0003H15.9393C13.806 20.3276 11.8479 21.4019 10.7888 23.1391C10.7279 23.2229 10.7812 23.3296 10.8879 23.3448Z",
    fill: "#643800"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8878 23.3449C10.9869 23.3601 11.0783 23.3297 11.1469 23.2687C12.3888 22.1716 14.3088 21.5773 15.7488 21.5773H16.0002H16.2516C17.6916 21.5773 19.6116 22.1716 20.8535 23.2687C20.9221 23.3297 21.0212 23.3601 21.1126 23.3449C21.2116 23.3297 21.265 23.223 21.2116 23.1392C21.204 23.124 21.1888 23.1087 21.1812 23.0858C21.0821 23.1392 20.9754 23.1925 20.8612 23.0782C19.6802 21.8287 17.9354 21.082 16.0612 21.082H15.9926H15.924C14.0421 21.082 12.2821 21.8363 11.1012 23.1087C10.9945 23.223 10.8954 23.1697 10.7964 23.1087C10.7888 23.124 10.7812 23.1316 10.7735 23.1468C10.7278 23.223 10.7812 23.3297 10.8878 23.3449Z",
    fill: "url(#paint5_linear_179_9011)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0804 11.7105C17.9508 11.2381 18.3851 10.8038 19.2613 10.5677C20.008 10.3695 21.7527 10.3391 23.2689 11.4895C23.5508 11.7029 23.2689 11.9315 23.0175 11.8172C22.1642 11.4134 20.107 11.1543 18.6975 11.7029C18.1337 11.9238 18.0804 11.7105 18.0804 11.7105Z",
    fill: "url(#paint6_linear_179_9011)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9773 16.655C20.6253 16.655 21.1506 15.8602 21.1506 14.8797C21.1506 13.8993 20.6253 13.1045 19.9773 13.1045C19.3293 13.1045 18.804 13.8993 18.804 14.8797C18.804 15.8602 19.3293 16.655 19.9773 16.655Z",
    fill: "url(#paint7_radial_179_9011)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9773 13.6991C20.4802 13.6991 20.9221 14.141 21.1506 14.7886C21.1354 13.8286 20.6173 13.0591 19.9773 13.0591C19.3373 13.0591 18.8192 13.8286 18.804 14.7886C19.0326 14.141 19.4744 13.6991 19.9773 13.6991Z",
    fill: "url(#paint8_linear_179_9011)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_179_9011",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5983 11.0596) scale(14.7062 14.7062)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_179_9011",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5983 11.0596) scale(11.57)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_179_9011",
    x1: 11.0196,
    y1: 12.5977,
    x2: 11.5463,
    y2: 10.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_179_9011",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6666 14.9247) rotate(73.8539) scale(1.72243 1.11438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_179_9011",
    x1: 12.0173,
    y1: 13.0587,
    x2: 12.0173,
    y2: 14.7898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_179_9011",
    x1: 15.9972,
    y1: 20.4493,
    x2: 15.9972,
    y2: 22.1562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_179_9011",
    x1: 20.9591,
    y1: 12.6449,
    x2: 20.4324,
    y2: 10.6792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_179_9011",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.6266 14.9249) rotate(73.8539) scale(1.72243 1.11438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_179_9011",
    x1: 19.9772,
    y1: 13.0587,
    x2: 19.9772,
    y2: 14.7898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrowning);
export default __webpack_public_path__ + "static/media/frowning.9fc48c6954c0ea49fdace903b5928e2e.svg";
export { ForwardRef as ReactComponent };